import React from 'react';
import PropTypes from 'prop-types';
import { FavouriteConstants, MixpanelEventName } from '../common/Constants';
import FavouriteIconComponent from './FavouriteIconComponent';
import NetworkingIconComponent from './NetworkingIconComponent';
import MixPanelHelper from '../common/MixPanelHelper';

export default class Favourite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      favourited: props.initialState,
      isAnonymousRegistrationEnabled: props.isAnonymousRegistrationEnabled
    };
    this.handleClick = this.handleClick.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    this.setState({
      favourited: newProps.initialState
    });
  }

  getFavouritePayload(currentAction) {
    return {
      actionName: currentAction,
      triggeringComponent: this.props.triggeringComponent,
      participationId: this.props.participationId,
      displayName: this.props.displayName,
      jobTitle: this.props.jobTitle,
      firstName: this.props.firstName,
      middleName: this.props.middleName,
      lastName: this.props.lastName,
      exhibitingOrganisationId: this.props.exhibitingOrganisationId,
      photoKey: this.props.photoKey,
      desktopImageUrl: this.props.desktopImageUrl,
      mobileImageUrl: this.props.mobileImageUrl,
      participantId: this.props.participantId,
      userId: this.props.userId
    };
  }

  getCurrentAction() {
    return this.state.favourited ? FavouriteConstants.participantFavourite : FavouriteConstants.participantUnfavourite;
  }

  getButtonData(isFavourited, translations, dtmData) {
    if (this.state.isAnonymousRegistrationEnabled) {
      if (isFavourited) {
        return {
          label: translations.removeFromMyNetwork,
          dtmTag: dtmData.removeFromMyNetworkIcon,
          altSVG: translations.removeFromMyNetwork,
          interactedElement: 'Remove from Network'
        };
      }
      return {
        label: translations.addToMyNetwork,
        dtmTag: dtmData.addToMyNetworkIcon,
        altSVG: translations.addToMyNetwork,
        interactedElement: 'Add to Network'
      };
    }
    if (isFavourited) {
      return {
        label: translations.remove,
        dtmTag: dtmData.unFavouriteIcon,
        altSVG: translations.removeFromFavourite,
        interactedElement: 'Unfavourite'
      };
    }
    return {
      label: translations.addToMyPlan,
      dtmTag: dtmData.favouriteIcon,
      altSVG: translations.addToFavourite,
      interactedElement: 'Favourite'
    };
  }

  getMixPanelPayload() {
    const buttonData = this.getButtonData(!this.state.favourited, this.props.translations, this.props.dtmData);
    const { dtmTag, interactedElement } = buttonData;
    const component = dtmTag.includes('participantDetail') ? 'Participant Detail' : 'Participant Directory';
    return {
      'Participation ID': this.props.participationId,
      'Interacted Element': interactedElement,
      Component: component,
      'Alias Event': dtmTag
    };
  }

  handleClick() {
    this.setState({
      favourited: !this.state.favourited
    }, () => {
      const currentAction = this.getCurrentAction();
      const favouritePayload = this.getFavouritePayload(currentAction);
      const mixpanelEventName = this.state.favourited ? MixpanelEventName.PlanAdded : MixpanelEventName.PlanRemoved;
      let mixpanelPayload = this.getMixPanelPayload();

      if (window && window.showPlanningReduxDispatcher) {
        if (favouritePayload.actionName === FavouriteConstants.participantFavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'participant/PARTICIPANT_ADDED_TO_PLAN', payload: favouritePayload });
          mixpanelPayload = { ...mixpanelPayload, 'Entity Added': 'Participant' };
        } else if (favouritePayload.actionName === FavouriteConstants.participantUnfavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'participant/PARTICIPANT_REMOVED_FROM_PLAN', payload: favouritePayload });
          mixpanelPayload = { ...mixpanelPayload, 'Entity Removed': 'Participant' };
        }
        if (this.props.isAnonymousRegistrationEnabled) {
          this.props.updateFolloweeList(this.props.userId, currentAction);
        }
        MixPanelHelper.trackGenericMixpanelEvents(mixpanelEventName, mixpanelPayload);
      }
    });
  }

  render() {
    const isFavourited = this.state.favourited;
    const buttonData = this.getButtonData(isFavourited, this.props.translations, this.props.dtmData);
    const { label, dtmTag, altSVG } = buttonData;
    const id = this.props.participationId;

    if (this.state.isAnonymousRegistrationEnabled) {
      return (
        this.props.enableNetworking
          ? (
            <div>
              <NetworkingIconComponent
                classname={this.props.classname}
                dtmTag={dtmTag}
                id={id}
                handleClick={this.handleClick}
                isAddedToMyNetwork={isFavourited}
                altSVG={altSVG}
                label={label}
                isDirectoryView={this.props.isDirectoryView}
              />
            </div>
          )
          : null
      );
    }

    if (this.props.showPlanningEnabled && !this.state.isAnonymousRegistrationEnabled) {
      return (
        <FavouriteIconComponent
          classname={this.props.classname}
          dtmTag={dtmTag}
          id={id}
          handleClick={this.handleClick}
          isFavourited={isFavourited}
          altSVG={altSVG}
          label={label}
          isDirectoryView={this.props.isDirectoryView}
        />
      );
    }
    return null;
  }
}

Favourite.propTypes = {
  classname: PropTypes.string,
  initialState: PropTypes.bool,
  participationId: PropTypes.string,
  triggeringComponent: PropTypes.string,
  dtmData: PropTypes.object,
  translations: PropTypes.object,
  showPlanningEnabled: PropTypes.bool,
  displayName: PropTypes.string,
  jobTitle: PropTypes.string,
  firstName: PropTypes.string,
  middleName: PropTypes.string,
  lastName: PropTypes.string,
  exhibitingOrganisationId: PropTypes.string,
  photoKey: PropTypes.string,
  desktopImageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string,
  participantId: PropTypes.string,
  enableNetworking: PropTypes.bool,
  userId: PropTypes.string,
  updateFolloweeList: PropTypes.func,
  isDirectoryView: PropTypes.bool,
  isAnonymousRegistrationEnabled: PropTypes.bool
};
